import { jsxs as p, jsx as i } from "react/jsx-runtime";
import { useState as g } from "react";
import { withManagedProps as y } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as H } from "@made-people/react-prop-guard";
import { motion as L } from "motion/react";
import { linksFluidImagesBlueprint as W } from "./index-blueprint.es.js";
import { useLink as F } from "@made-people/grease-link";
import { mediaSchema as d, Media as T } from "@made-people/blueprint-media";
import { buttonContentPropsSchema as u, Button as P } from "@made-people/blueprint-button";
import { componentWrapperSchema as S, ComponentWrapper as $ } from "@made-people/blueprint-component-wrapper";
import "@made-people/blueprint";
const w = t.object({
  layout: S.shape.layout.optional(),
  heading: t.string().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  buttonSettings: u.optional(),
  mediaSettings: d.optional(),
  items: t.object({
    link: t.object({
      target: t.string().optional(),
      href: t.string()
    }).optional(),
    title: t.string().optional(),
    media: d,
    button: u.optional()
  }).array().optional(),
  variants: t.custom().optional()
}), O = y(
  "LinksFluidImages",
  H(
    w,
    ({ layout: f, variants: v, buttonSettings: b, mediaSettings: r, ...e }) => {
      const o = W.styles(v), k = F(), [N, s] = g(-1), [I, l] = g(!1), j = (e == null ? void 0 : e.headingTag) || "h3";
      return /* @__PURE__ */ p($, { className: o.base, layout: f, children: [
        e.heading && /* @__PURE__ */ i(j, { className: o.heading, children: e.heading }),
        /* @__PURE__ */ i("div", { className: o.cardWrapper, children: e.items && e.items.map((a, n) => {
          var m, c, h;
          return /* @__PURE__ */ i(
            L.div,
            {
              className: o.item,
              onHoverStart: () => {
                s(n), l(!0);
              },
              onHoverEnd: () => {
                s(-1), l(!1);
              },
              children: /* @__PURE__ */ p(
                k,
                {
                  href: ((m = a.link) == null ? void 0 : m.href) ?? "",
                  title: a.title,
                  "data-is-hovering": I,
                  "data-is-active": N !== n && n !== -1 ? "false" : "true",
                  className: o.imageWrapper,
                  children: [
                    /* @__PURE__ */ i(
                      T,
                      {
                        ...r,
                        image: { ...r == null ? void 0 : r.image, ...(c = a.media) == null ? void 0 : c.image },
                        className: o.media
                      },
                      `category-link-${n}`
                    ),
                    (a == null ? void 0 : a.title) && /* @__PURE__ */ i("span", { className: o.itemTitle, children: a.title }),
                    ((h = a == null ? void 0 : a.button) == null ? void 0 : h.label) && /* @__PURE__ */ i("div", { className: o.buttonWrapper, children: /* @__PURE__ */ i(
                      P,
                      {
                        as: "span",
                        ...b,
                        ...a.button
                      }
                    ) })
                  ]
                }
              )
            },
            `${a.title}-${n}`
          );
        }) })
      ] });
    }
  )
);
export {
  O as LinksFluidImages,
  w as LinksFluidImagesPropsSchema
};
//# sourceMappingURL=index.es.js.map
